import React, { createContext, useContext, useEffect, useState } from "react";

import { BrandAPIPromiseClient } from "../gen/witbooking/loyalty/brand/v1/brand_api_grpc_web_pb";

import { ListBrandsRequest } from "../gen/witbooking/loyalty/brand/v1/brand_api_pb";
import { ACCESS_DENIED } from "../lib/auth";
import { useGrpcClient, useInternalGrpcCall } from "../lib/grpc";
import { useKeycloakAuthz } from "./keycloak-provider";

const LoyaltyAllBrand = createContext<any>(undefined);

export function LoyaltyAllBrandProvider({ children }: any) {
  const [data, setData] = useState<any>(undefined);
  const keycloakAuthz = useKeycloakAuthz();
  const grpcClient = useGrpcClient(BrandAPIPromiseClient);
  const listBrands = useInternalGrpcCall(grpcClient, grpcClient.listBrands);

  useEffect(() => {
    async function load() {
      try {
        const request = new ListBrandsRequest();
        const response = await listBrands(request);

        const brandsList = response
          .toObject()
          .brandsList.map(({ ticker, transactionExpirationLimit, id }) => ({
            ticker,
            transactionExpirationLimit,
            id,
          }));
        setData(brandsList);
      } catch (e) {
        if (e === ACCESS_DENIED) {
          console.error("Access denied", e);
        } else {
          console.error("Error retrieving rpt", e);
        }
      }
    }

    load();
  }, [keycloakAuthz, listBrands]);

  return (
    <LoyaltyAllBrand.Provider value={data}>
      {typeof children === "function" ? children(data) : children}
    </LoyaltyAllBrand.Provider>
  );
}

export function useLoyaltyAllBrand(): any {
  return useContext(LoyaltyAllBrand);
}

export const useLoyaltyAllBrands = useLoyaltyAllBrand;
